import { render, staticRenderFns } from "./LiquidacionProductoModelAddComponent.vue?vue&type=template&id=4a1ef804&"
import script from "./LiquidacionProductoModelAddComponent.vue?vue&type=script&lang=js&"
export * from "./LiquidacionProductoModelAddComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports